import React from 'react';
const pillars = [{
  letter: 'B',
  title: 'Biocycle Sleep',
  description: 'Hormonal synchronization to consolidate 7-10 hours of deep sleep'
}, {
  letter: 'A',
  title: 'Active Stimulation',
  description: '5-min micro-actions to skyrocket IQ and cognitive connection'
}, {
  letter: 'B',
  title: 'Bio-Nutrition',
  description: 'The evolutionary fuel map to build an elite brain'
}, {
  letter: 'Y',
  title: 'Youth Autonomy',
  description: 'The protocol for your baby to learn self-regulation'
}];
export function SolutionSection() {
  return <section id="solution" className="bg-gradient-to-br from-[#3D2B1F] to-[#6B4C3B] text-[#FAF7F2] py-16 px-5" data-id="element-253">
      <div className="max-w-[900px] mx-auto" data-id="element-254">
        <div className="text-center mb-2.5" data-id="element-255">
          <span className="inline-block bg-white/10 text-[#C9A96E] text-[11px] tracking-widest uppercase px-4 py-1.5 rounded-full font-sans font-bold" data-id="element-256">
            The Solution
          </span>
        </div>

        <h2 className="text-3xl md:text-4xl text-[#FAF7F2] mb-4 leading-tight text-center" data-id="element-257">
          The B.A.B.Y. 365 Protocol
        </h2>

        <p className="text-lg text-[rgba(250,247,242,0.7)] text-center max-w-[650px] mx-auto mb-12 italic" data-id="element-258">
          4 pillars of biological engineering for the first year of life
        </p>

        <div className="grid md:grid-cols-4 gap-6" data-id="element-259">
          {pillars.map((pillar, idx) => <div key={idx} className="bg-white/5 rounded-2xl p-6 text-center border border-white/10 transition-all hover:bg-[rgba(183,110,121,0.2)] hover:-translate-y-1" data-id="element-260">
              <div className="text-5xl font-bold text-[#B76E79] leading-none mb-2.5" data-id="element-261">
                {pillar.letter}
              </div>
              <h3 className="text-base text-[#FAF7F2] mb-2" data-id="element-262">{pillar.title}</h3>
              <p className="text-sm text-[rgba(250,247,242,0.7)] font-sans" data-id="element-263">
                {pillar.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}